import { ITranslateFn } from './types';


/*                                                                                */
let _translations: Record<string, string> = {};

/*                                                                       */
let _locale: string = '';


/* 
                                              
                                                                                      
  
                                                                           
                                                                                
 */
export function setTranslations(translations: Record<string, string>, locale?: string): void {
  _translations = translations;
  if (locale !== undefined) _locale = locale;
}

/* 
                                                                                  
                                                                                         
  
                              
                                                                                                        
                                                          
  
           
        
                                   
                                         
                                                                
      
 */
export function lang(key: string, defaultValue?: string): string {
  if (key in _translations) return _translations[key];
  return !!defaultValue ? defaultValue : key;
}

/* 
                                                
  
                                                                                
                                                                                              
                                                                                   
  
                                                                                          
                              
                                                                          
                                                          
  
           
        
                                       
                                  
                                                               
      
 */
export function langJson(translations: Record<string, Record<string, string>>, key: string, defaultValue?: string): string {
  const localTranslations = translations?.[_locale] ?? {};
  if (key in localTranslations) return localTranslations[key];
  if (key in _translations) return _translations[key];
  return !!defaultValue ? defaultValue : key;
}

/* 
                                                                        
                                                  
  
                                                                 
                                                     
  
                                       
                                                                           
                                                             
  
           
        
                                
                                           
                                                                                
      
 */
export function L(template: TemplateStringsArray, ...args: any[]): string {
  let key: string = template[0];
  for (let i = 1; i < template.length; i++) key += '{' + i + '}' + template[i];

  const translation = _translations[key] || key;
  let result = translation;

  for (let i = 0; i < args.length; i++) {
    result = result.replace('{' + (i + 1) + '}', String(args[i]));
  }
  return result;
}

/* 
                                                                  
                                              
  
                                                             
                                                                                     
  
                                                                           
                                                              
  
           
        
                            
                         
                                                                                                 
      
 */
export function createL(translate: ITranslateFn) {
  return function (template: TemplateStringsArray, ...args: any[]): string {
    let key: string = template[0];
    for (let i = 1; i < template.length; i++) key += '{' + i + '}' + template[i];

    const translation = translate(key);
    let result = translation;

    for (let i = 0; i < args.length; i++) {
      result = result.replace('{' + (i + 1) + '}', String(args[i]));
    }
    return result;
  };
}
